const appID = 'j3SkvJ6YeNsNuMG6lG1J';
const url = `https://us-central1-bookstore-api-e63c8.cloudfunctions.net/bookstoreApi/apps/${appID}`;

export default url;
